<template>
  <div class="flex bg-gray-100 min-h-screen mb-4">
    <!-- دورات -->
    <div class="w-full me-5">
      <section class="mb-8">
        <h2 class="text-xl font-bold mb-4">دورات قيد الإنجاز</h2>
        <div v-if="courses.filter(course => course.is_registered === true && course.is_completed === false).length">
          <CourseCard
              v-for="course in courses.filter(course => course.is_registered === true && course.is_completed === false && course.is_archived === false)"
              :key="course.id"
              :course_name="course.course_name"
              :course_type_text="course.course_type_text"
              :effort="course.effort"
              :course_image_url="course.course_image_url"
              :status="['in_progress']"
              :course_redirect_url="course.course_redirect_url"
              :details_type="course.details_type"
              :course_id="course.course_id"
              :reloadProgram="reloadProgram"
              class="mb-4"
          />
          <CourseCard
              v-for="course in courses.filter(course => course.is_registered === true && course.is_completed === false && course.is_archived === true)"
              :key="course.id"
              :course_name="course.course_name"
              :course_type_text="course.course_type_text"
              :effort="course.effort"
              :course_image_url="course.course_image_url"
              :status="['in_progress', 'archived']"
              :course_redirect_url="course.course_redirect_url"
              :details_type="course.details_type"
              :course_id="course.course_id"
              :reloadProgram="reloadProgram"
              class="mb-4"
          />
        </div>
        <div class="p-5 border-1 rounded text-gray-500 border-gray-500 " v-else> لا يوجد دورات</div>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-bold mb-4">الدورات المتبقية</h2>
        <div v-if="courses.filter(course => course.is_registered === false).length">
          <CourseCard
              v-for="course in courses.filter(course => course.is_registered === false && course.is_archived === false)"
              :key="course.id"
              :course_name="course.course_name"
              :course_type_text="course.course_type_text"
              :effort="course.effort"
              :course_image_url="course.course_image_url"
              :status="['available']"
              :course_redirect_url="course.course_redirect_url"
              :details_type="course.details_type"
              :course_id="course.course_id"
              :reloadProgram="reloadProgram"
              class="mb-4"
          />
          <CourseCard
              v-for="course in courses.filter(course => course.is_registered === false && course.is_archived === true)"
              :key="course.id"
              :course_name="course.course_name"
              :course_type_text="course.course_type_text"
              :effort="course.effort"
              :course_image_url="course.course_image_url"
              :status="['available', 'archived']"
              :course_redirect_url="course.course_redirect_url"
              :details_type="course.details_type"
              :course_id="course.course_id"
              :reloadProgram="reloadProgram"
              class="mb-4"
          />
        </div>
        <div class="p-5 border-1 rounded text-gray-500 border-gray-500 " v-else> لا يوجد دورات</div>
      </section>

      <section>
        <h2 class="text-xl font-bold mb-4">الدورات المنجزة</h2>
        <div v-if="courses.filter(course => course.is_completed === true).length">
          <CourseCard
              v-for="course in courses.filter(course => course.is_completed === true && course.is_archived === false)"
              :key="course.id"
              :course_name="course.course_name"
              :course_type_text="course.course_type_text"
              :effort="course.effort"
              :course_image_url="course.course_image_url"
              :status="['completed']"
              :course_redirect_url="course.course_redirect_url"
              :details_type="course.details_type"
              :course_id="course.course_id"
              :reloadProgram="reloadProgram"
              class="mb-4"
          />
          <CourseCard
              v-for="course in courses.filter(course => course.is_completed === true && course.is_archived === true)"
              :key="course.id"
              :course_name="course.course_name"
              :course_type_text="course.course_type_text"
              :effort="course.effort"
              :course_image_url="course.course_image_url"
              :status="['completed', 'archived']"
              :course_redirect_url="course.course_redirect_url"
              :details_type="course.details_type"
              :course_id="course.course_id"
              :reloadProgram="reloadProgram"
              class="mb-4"
          />
        </div>
        <div class="p-5 border-1 rounded text-gray-500 border-gray-500 " v-else> لا يوجد دورات</div>
      </section>
    </div>

    <!-- نسبة التقدم في البرنامج -->
    <div class="w-[40%] xl:w-[30%]  ms-2">
      <ProgramProgress
          :total_courses="courses.filter(course => !course.is_archived).length"
          :completed_courses="courses.filter(course => course.is_completed && !course.is_archived).length"
          :redirect_to_certification="redirect_to_certification"
          :is_completed="is_completed"
          :is_not_last_viewed="is_not_last_viewed"
          :show_new_courses_msg="isShowCertificateMessage()"
      />
    </div>
  </div>
</template>


<script>
import CourseCard from "~/components/public_programs/CourseCard.vue";
import ProgramProgress from "~/components/public_programs/ProgramProgress.vue";

export default {
  components: {
    CourseCard,
    ProgramProgress
  },
  props: {
    courses: {
      required: true
    },
    redirect_to_certification: {
      required: false
    },
    is_completed: {
      required: false
    },
    is_not_last_viewed: {
      required: false
    },
    reloadProgram: {
      required: false
    },
    show_new_courses_msg: {
      required: false
    }
  },
  methods: {
    isShowCertificateMessage() {
      const not_passed_array = this.courses.filter(course => {
        if (!course.is_archived && !course.is_completed) {
          return course
        }
      })
      const is_all_passed = not_passed_array.length === 0;
      return this.show_new_courses_msg && !is_all_passed
    }
  }
};
</script>

